<!-- [tooltip]="btnConfig?.toolTip" [placement]="btnConfig?.placement" -->
<button [id]="btn?.id" [disabled]="btn?.disabled" (click)="callBtnEvent($event)"
    [class.alt]="btn?.alt" [class.inherit-width]="btn?.inheritWidth" [class.font-bold]="btn?.fontBold"
    [tooltip]="btn?.toolTip || ''" [placement]="btn?.placement || 'top'">
        <i *ngIf="btn?.icon" [ngClass]="btn?.icon || ''"></i>
        {{ btn?.label }}
</button>
